module.exports = __webpack_public_path__ + "static/img/Lark20220424-175950.08946df6.png";